module.exports = __webpack_public_path__ + "img/collapse-dark-blue.aa9d900a.svg";